var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGrowthChart = function SvgGrowthChart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6665 2.33317C25.6665 1.4127 26.4127 0.666504 27.3332 0.666504H35.6665C36.587 0.666504 37.3332 1.4127 37.3332 2.33317V10.6665C37.3332 11.587 36.587 12.3332 35.6665 12.3332C34.746 12.3332 33.9998 11.587 33.9998 10.6665V3.99984H27.3332C26.4127 3.99984 25.6665 3.25365 25.6665 2.33317Z",
    fill: "#0357FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1438 2.13704C36.7124 2.86082 36.5867 3.90858 35.8629 4.47727L24.1963 13.6439C23.6188 14.0977 22.8124 14.1199 22.2108 13.6988L14.8999 8.58114L3.37439 17.8015C2.65562 18.3765 1.6068 18.26 1.03178 17.5412C0.456768 16.8225 0.573304 15.7736 1.29207 15.1986L13.7921 5.19862C14.3698 4.73648 15.1829 4.71044 15.789 5.13468L23.1092 10.2589L33.8035 1.85621C34.5273 1.28752 35.5751 1.41325 36.1438 2.13704Z",
    fill: "#0357FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49967 19C7.42015 19 8.16634 19.7462 8.16634 20.6667V35.6667C8.16634 36.5871 7.42015 37.3333 6.49967 37.3333C5.5792 37.3333 4.83301 36.5871 4.83301 35.6667V20.6667C4.83301 19.7462 5.5792 19 6.49967 19Z",
    fill: "#0357FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8332 12.333C15.7536 12.333 16.4998 13.0792 16.4998 13.9997V35.6663C16.4998 36.5868 15.7536 37.333 14.8332 37.333C13.9127 37.333 13.1665 36.5868 13.1665 35.6663V13.9997C13.1665 13.0792 13.9127 12.333 14.8332 12.333Z",
    fill: "#0357FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1667 17.333C24.0871 17.333 24.8333 18.0792 24.8333 18.9997V35.6663C24.8333 36.5868 24.0871 37.333 23.1667 37.333C22.2462 37.333 21.5 36.5868 21.5 35.6663V18.9997C21.5 18.0792 22.2462 17.333 23.1667 17.333Z",
    fill: "#0357FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4997 14C32.4202 14 33.1663 14.7462 33.1663 15.6667V35.6667C33.1663 36.5871 32.4202 37.3333 31.4997 37.3333C30.5792 37.3333 29.833 36.5871 29.833 35.6667V15.6667C29.833 14.7462 30.5792 14 31.4997 14Z",
    fill: "#0357FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrowthChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/growthChart.1a59722d.svg";
export { ForwardRef as ReactComponent };